import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./pages/home/home.page').then(m => m.HomeComponent)
    },
    {
        path: 'servicos',
        loadComponent: () => import('./pages/services/services.page').then(m => m.ServicesComponent)
    },
    {
        path: 'contato',
        loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactComponent)
    },
    {
        path: 'politica-de-privacidade',
        loadComponent: () => import('./pages/privacy/privacy.page').then(m => m.PrivacyComponent)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
